/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./Table.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var Checkbox_1 = require("./Checkbox");
var Icon_1 = require("./Icon");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-table");
exports.Table = function Table(_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement("table", tslib_1.__assign({ className: classnames(moduleClassName(), className) }, props), children));
};
exports.TableResponsive = function TableResponsive(_a) {
    var padded = _a.padded, props = tslib_1.__rest(_a, ["padded"]);
    return (React.createElement("div", { className: classnames(moduleClassName("responsive"), !!padded && moduleClassName("padded")) },
        React.createElement(exports.Table, tslib_1.__assign({}, props))));
};
exports.TableHeadCell = function TableHeadCell(_a) {
    var children = _a.children, sortable = _a.sortable, sort = _a.sort, alignedRight = _a.alignedRight, className = _a.className, props = tslib_1.__rest(_a, ["children", "sortable", "sort", "alignedRight", "className"]);
    return (React.createElement("th", tslib_1.__assign({ className: classnames(moduleClassName("headCell"), sortable && moduleClassName("headCell-isSortable"), !!sort && moduleClassName("headCell-isActive"), !!alignedRight && moduleClassName("headCell-alignedRight"), className) }, props),
        children,
        (!!sort || sortable) && (React.createElement(Icon_1.Icon, { type: sort === "asc" ? "arrow-down" : "arrow-up" }))));
};
exports.TableHead = function TableHead(_a) {
    var children = _a.children, className = _a.className, checkbox = _a.checkbox, props = tslib_1.__rest(_a, ["children", "className", "checkbox"]);
    return (React.createElement("thead", tslib_1.__assign({ className: classnames(moduleClassName("head"), className) }, props),
        React.createElement("tr", null,
            !!checkbox && (React.createElement(exports.TableCheckbox, tslib_1.__assign({ Component: exports.TableHeadCell }, checkbox))),
            children)));
};
exports.TableBody = function TableBody(_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement("tbody", tslib_1.__assign({ className: classnames(moduleClassName("body"), className) }, props), children));
};
exports.TableCell = function TableCell(_a) {
    var children = _a.children, nowrap = _a.nowrap, alignedRight = _a.alignedRight, className = _a.className, props = tslib_1.__rest(_a, ["children", "nowrap", "alignedRight", "className"]);
    return (React.createElement("td", tslib_1.__assign({ className: classnames(moduleClassName("cell"), nowrap && moduleClassName("cell-isNowrap"), alignedRight && moduleClassName("cell-alignedRight"), className) }, props), children));
};
exports.TableCheckbox = function TableCheckbox(_a) {
    var onChange = _a.onChange, Component = _a.Component, props = tslib_1.__rest(_a, ["onChange", "Component"]);
    return (React.createElement(Component, { className: moduleClassName("cell-small") },
        React.createElement(Checkbox_1.Checkbox, tslib_1.__assign({ onClick: function (e) { return e.stopPropagation(); }, onChange: onChange }, props))));
};
exports.TableRow = function TableRow(_a) {
    var children = _a.children, onClick = _a.onClick, className = _a.className, expired = _a.expired, checkbox = _a.checkbox, props = tslib_1.__rest(_a, ["children", "onClick", "className", "expired", "checkbox"]);
    return (React.createElement("tr", tslib_1.__assign({ className: classnames(moduleClassName("row"), !!checkbox && !!checkbox.checked && moduleClassName("row-isSelected"), !!expired && moduleClassName("row-isExpired"), className), onClick: onClick }, props),
        !!checkbox && React.createElement(exports.TableCheckbox, tslib_1.__assign({ Component: exports.TableCell }, checkbox)),
        children));
};